<template>
    <div class="solution-page">
        <div class="page-introduction">
            <img class="header-image" :src="imageTextList[tabIndex].image" v-if="channelWidth>768"/>
            <img class="header-image" :src="phoneImageList[tabIndex].image" v-else/>
            <div class="header-info">
                <div class="content-title" :class="[channelWidth<1500?(channelWidth<1200?'more-long':'long-width'):'']">
                    {{imageTextList[tabIndex].name}}
                </div>
                <div class="introduction-content"  :class="[channelWidth<1400?(channelWidth<1200?'more-long':'long-width'):'']">
                    {{imageTextList[tabIndex].info}}
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
    import SolutionHeadBg from '../../image/common/solution_banner.png'
    import SolutionEnvironmentBg from '../../image/common/environment_bg.png'
    import SolutionAdministrationBg from  '../../image/common/administration_banner.png'
    import SolutionChemicalBg from  '../../image/common/chemical_industry_bg.png'
    import SolutionConstructionBg from '../../image/common/construction_bg.png'
    import SolutionAgricultureBg from '../../image/agriculture_bg.png'
    import PhoneSchool from '../../image/common/phone_school.png'
    import PhoneEnvironment from '../../image/common/phone_environment.png'
    import PhoneAdministration from '../../image/common/phone_administration.png'
    import PhoneChemical from '../../image/common/phone_chemical.png'
    import PhoneConstruction from '../../image/common/phone_construction.png'
    import PhoneAgriculture from '../../image/common/phone_agriculture.png'


    export default {
        name: "solution-page",
        data(){
            return{
                imageTextList:[
                    {name:'智慧校园',key:'school',image:SolutionHeadBg,info:'利用新一代物联网技术和智能感知设备构建校园智能化网络，帮助用户提升教学、科研和办公设备使用、维护和管理的效率，降低管理成本和人工成本，实现校园设备及能耗管理的实效化、精细化、智能化、决策的科学化，促进智能型校园、节能型校园和平安校园的建设。'},
                    {name:'智慧环保',key:'environment',image:SolutionEnvironmentBg,info:'  “智慧环保”是互联网技术与环境信息化相结合的概念。智慧环保是智慧城市的组成部份，它借助物联网技术的数字环保平台，集在线监测监控网络、环境应急指挥系统融合，结合物联网、云计算、多网融合等多种技术方案，通过实时采集污染源排放因子、环境质量、环境生态、环境风险、企业信息管理等信息，构建全方位、多层次、立体化、全覆盖的生态环境监测网络，构筑感知测量更透彻、互联互通更可靠、智能应用更深入的智慧环保物联网体系，以更加精细和动态的方式实现环境管理和决策，从而实现环境保护智慧化。'},
                    {name:'智慧城管',key:'administration',image:SolutionAdministrationBg,info:'随着智慧城市的推广以及新一代高新技术的普及，“智慧城管”作为智慧城市的重要载体和城市智慧落地的触点，智慧城管的建设开展得如火如荼。党中央、国务院立足于我国信息化和新型城镇化发展实际，本着以人为本执政核心，为提升基层社会治理和城市管理服务水平，为社区居民提供一个安全、舒适、便利的现代化、智慧化生活环境，致力于推动到2020 年，使全国50%以上的社区实现智慧社区的标准化建设，同时建立可持续发展的社区治理体系和智能化社会服务模式，建立完善的社区服务体系。'},
                    {name:'智慧化工',key:'chemical-industry',image:SolutionChemicalBg,info:'近年来，人们谈“化”色变，一系列化工企业爆炸事故的发生，可谓触目惊心、教训惨重，安全生产警钟常鸣。从国家到省市县，都相继出台了有关化工园区的一系列整改文件规章。智慧化工园区的建设迫在眉睫。但化工园区不同于其它园区（如物流园区或软件园区等），具有其特殊性。智慧园区的建设，需要更多地依赖于终端传感设备的部署。通过对设备工况监测、智慧消防部署、二道门管理、人员资产定位，确保安全生产；通过配电管控，以及对水、气、土壤、噪声、固体危险废物的监测，保护生态环境；最后，通过工厂内的人、机、物、环等要素的监测，实现智慧工厂发展目标'},
                    {name:'智慧工地',key:'construction',image:SolutionConstructionBg,info:'建筑工地行业是我国国民经济的重要物质生产部门和支柱产业之一，在改善居住条件、完善基础设施、吸纳劳动力就业、推动经济增长等方面发挥着重要作用。与此同时，建筑业也是一个安全事故多发的高危行业。近年来，在国家、各级地方政府主管部门和行业主体的高度关注和共同努力下，建筑施工安全生产事故逐年下降，质量水平大幅提升，但不可否认，形势依然较为严峻，尤其是随着我国城市化进程的不断推进，建设工程规模也将继续扩大，建筑施工质量安全仍不可掉以轻心。 如何加强施工现场安全管理、降低事故发生频率、杜绝各种违规操作和不文明施工、提高建筑工程质量，仍将是摆在各级政府部门、业界人士和广大学者面前的一项重要研究课题。'},
                    {name:'智慧农业',key:'agriculture',image:SolutionAgricultureBg,info:'随着智慧农业的推广以及新一代高新技术的普及，智慧农业的建设开展得如火如荼。农业物联网正在引领农业传统生产经营模式的变革和升级，成为改变农业、农民、农村的新力量。国际上许多发达国家正在加速推进农业物联网的技术研发和产业化应用，产生了很多新型传感装备、软件系统和产业化应用模式。针对国际上农业物联网的技术研究和产业 化发展现状，分析美国、欧盟、日韩等先进国家和地区在传感器装备、软件系统、农户应用等各方面的最新进展，并比较它们各自的优势特色。最后，结合当前我国农业物联网的发展现状和遇到的问题，对于探索农业物联网理论研究、系统集成、重点领域、发展模式及推进路径，提高农业物联网理论及应用水平，促进农业生产方式转变、农民增收有重要意义。'},
                ],
                phoneImageList:[
                    {image:PhoneSchool},
                    {image:PhoneEnvironment},
                    {image:PhoneAdministration},
                    {image:PhoneChemical},
                    {image:PhoneConstruction},
                    {image:PhoneAgriculture},
                ],
                tabIndex:0,
                pageKey:'school',//页面识别参数，默认first
                channelWidth: null,      //浏览器窗口宽度
            }
        },
        watch:{
            /**
             * 浏览器宽度变化赋值
             * @param newVal
             */
            '$store.state.screenWidth'(newVal){
                // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
                if (!this.timer) {
                    // 一旦监听到的productWidth值改变，就将其重新赋给data里的channelWidth.
                    this.channelWidth = newVal
                    this.timer = true;
                    setTimeout(() => {
                        // console.log(this.channelWidth);
                        this.timer = false;
                    }, 400);
                }
            },
            '$store.state.solutionBlockKey'(newVal){
                console.log(newVal)
                this.pageKey = newVal;
                this.tabIndex = this.imageTextList.findIndex(item=>{
                    return item.key === newVal
                })
            },
            /**
             * 路由监听
             */
            $route(to,from) {
                let path = to.path,
                    list = this.imageTextList;
                list.forEach((item,index) =>{
                    if(path.indexOf(item.key) != -1){
                        this.tabIndex = index;
                    }
                })
            }
        },
        created(){
            console.log('开始')
            this.imageTextList.forEach((item,index) =>{
                if(this.$route.path.indexOf(item.key) !== -1){
                    this.pageKey = item.key;
                    this.tabIndex = index
                }
            })
        },
        mounted() {
            console.log('开始')
            //获取浏览器宽度
            this.channelWidth = this.$store.state.screenWidth;
        }
    }
</script>

<style lang="scss" src="./solution-page.scss" scoped>

</style>
